import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getAuthToken, clearAuthToken } from './authToken';

// ── Authentification centralisée ────────────────────────────────────────────
// Ces deux intercepteurs s'appliquent à l'instance axios par défaut, donc à la
// TOTALITÉ des appels du projet (≈ 276 répartis dans ~55 fichiers) sans avoir à
// modifier un seul de ces fichiers.
axios.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Session expirée : on ne purge et on ne redirige QUE si un token existait.
    // Sans cette condition, un visiteur anonyme du site public serait renvoyé
    // vers la page de connexion au moindre 401.
    if (error.response?.status === 401 && getAuthToken()) {
      clearAuthToken();
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();